namespace Nobox.Master {
    export interface StatesListRequest extends Serenity.ListRequest {
        Country?: string;
    }
}
